import api from "../utils/api";
import * as actionTypes from './types';
import setAlert from './setAlert';
import axios from 'axios';
import GireApi from "../utils/gire_api";


export const getPropertyCategory = (username) => async (dispatch) => {
    try {
        dispatch({
            type: actionTypes.GET_PROPERTY_CATEGORY_LOADER,
            payload: true
        });

        const res = await api.get(`/category/`);
        if (parseInt(res.data.status) === 200) {
            dispatch({
                type: actionTypes.GET_PROPERTY_CATEGORY_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GET_PROPERTY_CATEGORY,
                payload: res.data.data?res.data.data:[]
            });
        }
        else {
            dispatch({
                type: actionTypes.GET_PROPERTY_CATEGORY_LOADER,
                payload: false
            });
        }

    } catch (err) {
        dispatch({
            type: actionTypes.GET_PROPERTY_CATEGORY_LOADER,
            payload: false
        });
    }
};


export const getPropertySubCategory = (id) => async (dispatch) => {
    try {
        dispatch({
            type: actionTypes.GET_PROPERTY_SUB_CATEGORY_LOADER,
            payload: true
        });

        const res = await api.get(`/subcategory/byCategory/${id}`);
        console.log(res.data, "res......")
        if (parseInt(res.status) === 200) {
            dispatch({
                type: actionTypes.GET_PROPERTY_SUB_CATEGORY_LOADER,
                payload: false
            });

            dispatch({
                type: actionTypes.GET_PROPERTY_SUB_CATEGORY,
                payload: res.data
            });
        }
        else {
            dispatch({
                type: actionTypes.GET_PROPERTY_SUB_CATEGORY_LOADER,
                payload: false
            });
        }

    } catch (err) {
        dispatch({
            type: actionTypes.GET_PROPERTY_CATEGORY_LOADER,
            payload: false
        });
    }
};

// GET ALL COUNTRY
export const getAllCountry = (username) => async (dispatch) => {
    try {
        dispatch({
            type: actionTypes.GET_COUNTRIES_LOADER,
            payload: true
        });

        const res = await api.get(`/countries`);
        if (parseInt(res.data.status) === 200) {
            dispatch({
                type: actionTypes.GET_COUNTRIES_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GET_COUNTRIES,
                payload: res.data.data
            });
        }
        else {
            dispatch({
                type: actionTypes.GET_COUNTRIES_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GET_COUNTRIES,
                payload: []
            });
        }

    } catch (err) {
        dispatch({
            type: actionTypes.GET_COUNTRIES_LOADER,
            payload: false
        });
    }
};

// Remove Countries DAta
export const actionRemoveCountries = (id) => async (dispatch) => {
    dispatch({
        type: actionTypes.GET_COUNTRIES,
        payload: []
    });
};

// Remove States DAta
export const actionRemoveStates = (id) => async (dispatch) => {
    dispatch({
        type: actionTypes.GET_STATES,
        payload: []
    });
};
// Remove Cities DAta
export const actionRemoveCities = (id) => async (dispatch) => {
    dispatch({
        type: actionTypes.GET_CITIES,
        payload: []
    });
};


// GET STATES
export const getStates = (id) => async (dispatch) => {
    try {
        dispatch({
            type: actionTypes.GET_STATES_LOADER,
            payload: true
        });

        const res = await api.get(`/states/ByCountry/${id}`);
        if (parseInt(res.status) === 200) {
            dispatch({
                type: actionTypes.GET_STATES_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GET_STATES,
                payload: res.data
            });
        }
        else {
            dispatch({
                type: actionTypes.GET_STATES_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GET_STATES,
                payload: []
            });
        }

    } catch (err) {
        dispatch({
            type: actionTypes.GET_STATES_LOADER,
            payload: false
        });
    }
};


// GET CITIES
export const getCities = (id) => async (dispatch) => {
    try {
        dispatch({
            type: actionTypes.GET_CITIES_LOADER,
            payload: true
        });

        const res = await api.get(`/cities/ByState/${id}`);
        if (parseInt(res.status) === 200) {
            dispatch({
                type: actionTypes.GET_CITIES_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GET_CITIES,
                payload: res.data
            });
        }
        else {
            dispatch({
                type: actionTypes.GET_CITIES_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GET_CITIES,
                payload: []
            });
        }

    } catch (err) {
        dispatch({
            type: actionTypes.GET_CITIES_LOADER,
            payload: false
        });
    }
};


// Get UnitOfMeasures
export const getUnitOfMeasures = (id) => async (dispatch) => {
    try {
        dispatch({
            type: actionTypes.GET_UNIT_OF_MEASURES_LOADER,
            payload: true
        });

        const res = await api.get(`/UnitOfMeasures`);
        if (parseInt(res.status) === 200) {
            dispatch({
                type: actionTypes.GET_UNIT_OF_MEASURES_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GET_UNIT_OF_MEASURES,
                payload: res.data
            });
        }
        else {
            dispatch({
                type: actionTypes.GET_UNIT_OF_MEASURES_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GET_UNIT_OF_MEASURES,
                payload: []
            });
        }

    } catch (err) {
        dispatch({
            type: actionTypes.GET_UNIT_OF_MEASURES_LOADER,
            payload: false
        });
    }
};


//ADD Property
export const actionAddProperty = (request, history) => async (dispatch) => {

    try {
        dispatch({
            type: actionTypes.ADD_PROPERTY_LOADER,
            payload: true
        });

        const res = await api.post(`/properties`, JSON.stringify(request));
        if (parseInt(res.data.status) === 200) {
            dispatch({
                type: actionTypes.ADD_PROPERTY_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.ADD_PROPERTY,
                payload: res.data
            });
            history && history.push("/private-properties");
            dispatch(setAlert(res.data.data.msg), 'success')
        }
        else {
            dispatch({
                type: actionTypes.ADD_PROPERTY_LOADER,
                payload: false
            });
            dispatch(setAlert(res.data.data.message), 'error')
        }

    } catch (err) {
        dispatch({
            type: actionTypes.GET_UNIT_OF_MEASURES_LOADER,
            payload: false
        });
        console.log(err)
        // dispatch(setAlert(res.data.data.msg),'error')
    }
};

//ADD Property
export const actionUpdateProperty = (request, history,id) => async (dispatch) => {

    try {
        dispatch({
            type: actionTypes.UPDATE_PROPERTY_LOADER,
            payload: true
        });

        const res = await api.put(`/properties/${id}`, JSON.stringify(request));
        if (parseInt(res.data.status) === 200) {
            dispatch({
                type: actionTypes.UPDATE_PROPERTY_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.UPDATE_PROPERTY,
                payload: res.data
            });
            history && history.push("/private-properties");
            dispatch(setAlert(res.data.data.msg), 'success')
        }
        else {
            dispatch({
                type: actionTypes.UPDATE_PROPERTY_LOADER,
                payload: false
            });
            dispatch(setAlert(res.data.data.message), 'error')
        }

    } catch (err) {
        dispatch({
            type: actionTypes.UPDATE_PROPERTY_LOADER,
            payload: false
        });
        console.log(err)
        // dispatch(setAlert(res.data.data.msg),'error')
    }
};
// Get SINGLE PROPERTY DETAILS
export const actionGetPropertyDetails = (id, history) => async (dispatch) => {

    try {
        dispatch({
            type: actionTypes.GET_PROPERTY_DETAILS_LOADER,
            payload: true
        });

        const res = await api.get(`/properties/${id}`);
        if (parseInt(res.data.status) === 200) {
            dispatch({
                type: actionTypes.GET_PROPERTY_DETAILS_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GET_PROPERTY_DETAILS,
                payload: res.data.data
            });
            // dispatch(setAlert(res.data.data.msg), 'success')
        }
        else {
            dispatch(setAlert(res.data.message), 'error')
            dispatch({
                type: actionTypes.GET_PROPERTY_DETAILS_LOADER,
                payload: false
            });

        }

    } catch (err) {
        const errors = err.response&&err.response.data.errors;
        if (errors) {
            errors.forEach(error => dispatch(setAlert(error.msg), 'error'))
        }
        dispatch({
            type: actionTypes.GET_UNIT_OF_MEASURES_LOADER,
            payload: false
        });
    }
};



// Get Upload Property Image
export const actionUploadPropertyImage = (request,setPropertyImagePreview) => async (dispatch) => {

    try {
        dispatch({
            type: actionTypes.UPLOAD_PROPERTY_IMAGE_LOADER,
            payload: true
        });

        const res = await api.post(`/upload`, request,{headers: {'Content-Type': 'multipart/form-data'}});
        if (parseInt(res.data.status) === 200) {
            dispatch({
                type: actionTypes.UPLOAD_PROPERTY_IMAGE_LOADER,
                payload: false
            });

            dispatch({
                type: actionTypes.UPLOAD_PROPERTY_IMAGE,
                payload: res.data.image
            });
            setPropertyImagePreview && setPropertyImagePreview(res.data.image,res.data.file_name);
            dispatch(setAlert(res.data.message), 'success')

        }
        else {
            dispatch({
                type: actionTypes.UPLOAD_PROPERTY_IMAGE_LOADER,
                payload: false
            });
            dispatch(setAlert(res.data.message), 'error')
        }

    } catch (err) {
        dispatch({
            type: actionTypes.UPLOAD_PROPERTY_IMAGE_LOADER,
            payload: false
        });
        console.log(err)
        // dispatch(setAlert(res.data.data.msg),'error')
    }
};

// Get ALL Properties List
export const actionGetAllPropertyList = (request, setLastData) => async (dispatch, getState) => {
    dispatch({type: actionTypes.GET_ALL_PROPERTIES_LIST_LOADER, payload: true});
    (request.q && parseInt(request.offset) === 0) && dispatch({
        type: actionTypes.REMOVE_PROPERTIES,
        payload: []
    });
    (!request.q.length > 0 && parseInt(request.offset) === 0) && dispatch({
        type: actionTypes.REMOVE_PROPERTIES,
        payload: []
    });
    try {
        let result = await api.post(`/properties/get-properties`, JSON.stringify(request));
        dispatch({type: actionTypes.GET_ALL_PROPERTIES_LIST_LOADER, payload: false});
        if (parseInt(result.data.status) === 200) {
            (request.q && parseInt(request.offset) === 0) && dispatch({
                type: actionTypes.REMOVE_PROPERTIES,
                payload: []
            });
            (!request.q.length > 0 && parseInt(request.offset) === 0) && dispatch({
                type: actionTypes.REMOVE_PROPERTIES,
                payload: []
            });
            if (result.data.data && result.data.data.length > 0) {
                setLastData && setLastData(true);
                dispatch({type: actionTypes.GET_ALL_PROPERTIES_LIST, payload: result.data.data});
                dispatch({type: actionTypes.GET_PROPERTIES_COUNT, payload: result.data.property_count});
            }
            else {
                setLastData && setLastData(false);
                dispatch({type: actionTypes.GET_PROPERTIES_COUNT, payload: result.data.property_count});
            }

        }
        else {
            dispatch({
                type: actionTypes.REMOVE_PROPERTIES,
                payload: []
            })
            dispatch({type: actionTypes.GET_PROPERTIES_COUNT, payload: result.data.property_count});

        }
    } catch (error) {
        setAlert(error.message, 'error');
    }
};

export const actionGetSuggestedLocations = (query) => async (dispatch, getState) => {
    dispatch({type: actionTypes.GET_SUGGESTED_LOCATION_LOADER, payload: true});
    try {
        let result = await axios.get(`https://api.globalindiarealestate.com/ws/get-suggested-locations?query=${query}`);
        dispatch({type: actionTypes.GET_SUGGESTED_LOCATION_LOADER, payload: false});
        console.log(result.data,'result');
        if (parseInt(result.data.status) === 200) {
            dispatch({type: actionTypes.GET_SUGGESTED_LOCATIONS, payload: result.data.data});
        } else dispatch({type: actionTypes.GET_SUGGESTED_LOCATIONS, payload: []});
    } catch (error) {
        dispatch({type: actionTypes.GET_SUGGESTED_LOCATION_LOADER, payload: false});
    }
};


export const addToLikeProperty = (propertyID,userId) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.LIKE_PROPERTY_LOADER,
            payload: true
        });
        const res = await api.put(`/properties/like/${propertyID}`,JSON.stringify({user:userId}));
        if (parseInt(res.data.status) === 200) {
        dispatch({
            type: actionTypes.LIKE_PROPERTY_DATA,
            payload: res.data.data
        });
        dispatch({
            type: actionTypes.LIKE_PROPERTY_LOADER,
            payload: false
        });
            //setAlert(res.data.message, 'success');
        }else{
            setAlert(res.data.message, 'error');
        }
        // dispatch(loadUser());
    } catch (err) {
        if (err) {
            setAlert(err.message, 'error')
        }
    }
};

export const addToUnLikeProperty = (propertyID,userId) => async dispatch => {
    try {
        dispatch({
            type: actionTypes.UNLIKE_PROPERTY_LOADER,
            payload: true
        });
        const res = await api.put(`/properties/unlike/${propertyID}`,JSON.stringify({user:userId}));
        if (parseInt(res.data.status) === 200) {
            dispatch({
                type: actionTypes.UNLIKE_PROPERTY_DATA,
                payload: res.data.data
            });
            dispatch({
                type: actionTypes.UNLIKE_PROPERTY_LOADER,
                payload: false
            });
            //setAlert(res.data.message, 'success');
        }else{
            setAlert(res.data.message, 'error');
        }
        // dispatch(loadUser());
    } catch (err) {
        if (err) {
            setAlert(err.message, 'error')
        }
    }
};



// Get Amenities
export const getAmenities = (id) => async (dispatch) => {
    try {
        dispatch({
            type: actionTypes.GET_AMENITIES_LOADER,
            payload: true
        });

        const res = await api.get(`/amenities`);
        if (parseInt(res.data.status) === 200) {
            dispatch({
                type: actionTypes.GET_AMENITIES_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GET_AMENITIES,
                payload: res.data.data
            });
        }
        else {
            dispatch({
                type: actionTypes.GET_AMENITIES_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.GET_AMENITIES,
                payload: []
            });
        }

    } catch (err) {
        dispatch({
            type: actionTypes.GET_AMENITIES_LOADER,
            payload: false
        });
    }
};




//ADD_UPDATE  Property To Global India Realestate
export const actionAddPropertyToGIRE = (request) => async (dispatch) => {
    try {
        dispatch({
            type: actionTypes.ADD_PROPERTY_TO_GIRE_LOADER,
            payload: true
        });

        const result = await GireApi.post(`/add-property`, JSON.stringify(request));
        if (parseInt(result.data.status) === 200) {
            dispatch({
                type: actionTypes.ADD_PROPERTY_TO_GIRE_LOADER,
                payload: false
            });
            dispatch({
                type: actionTypes.ADD_PROPERTY_TO_GIRE,
                payload: result.data.data
            });
            // dispatch(setAlert(result.data.message), 'success')
        }
        else {
            dispatch({
                type: actionTypes.ADD_PROPERTY_TO_GIRE_LOADER,
                payload: false
            });
            dispatch(setAlert(result.data.data.message), 'error')
        }
    } catch (err) {
        setAlert(err.message, 'error');
        dispatch({
            type: actionTypes.ADD_PROPERTY_TO_GIRE_LOADER,
            payload: false
        });
        console.log(err)
        // dispatch(setAlert(res.data.data.msg),'error')
    }
};